import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide3TwoSteps.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide3Pause(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15, ease }}
        className="mt-4 flex flex-col items-center justify-center gap-4"
      >
        <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-full border-2 border-slate-300 text-slate-900">
          <div className="flex items-center gap-2 sm:gap-2.5">
            <span className="block h-7 w-2 sm:h-9 sm:w-2.5 rounded-full bg-current" />
            <span className="block h-7 w-2 sm:h-9 sm:w-2.5 rounded-full bg-current" />
          </div>
        </div>

        <h2 className="text-4xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05] text-center">
          {c.title}
        </h2>
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.35, ease }}
        className="mt-5 text-lg sm:text-2xl text-slate-500 leading-relaxed max-w-[52rem]"
      >
        {c.body}
      </motion.p>
    </div>
  )
}
